import type { BuildSchematic } from '../types/buildTeam';

/**
 * The name to show for a schematic or screenshot: the title the uploader gave it,
 * or the filename without its extension for files uploaded before titles existed.
 */
export function schematicDisplayTitle(schematic: Pick<BuildSchematic, 'title' | 'filename'>): string {
  const title = schematic.title?.trim();
  if (title) return title;
  const filename = schematic.filename.trim();
  const dot = filename.lastIndexOf('.');
  return dot > 0 ? filename.slice(0, dot) : filename || 'Untitled file';
}

/** True when the title shown is different from the filename, so the filename is worth showing too. */
export function schematicShowsFilename(schematic: Pick<BuildSchematic, 'title' | 'filename'>): boolean {
  return schematicDisplayTitle(schematic) !== schematic.filename;
}
